import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

function showPremiumSwal(navigate: ReturnType<typeof useNavigate>) {
  Swal.fire({
    title: 'Frecuencias RFW Exclusivas',
    html: `
      <div class="text-left space-y-4">
        <p class="text-foreground-700 text-sm leading-relaxed">
          Cada frecuencia RFW es <strong class="text-primary-600">única y exclusiva</strong>. Una vez asignada, esa posición en el dial digital queda reservada para siempre.
        </p>
        <div class="bg-background-100 rounded-xl p-4 space-y-3">
          <div class="flex items-start gap-3">
            <div class="w-8 h-8 rounded-lg bg-accent-100 flex items-center justify-center shrink-0 mt-0.5">
              <i class="ri-radar-line text-accent-600 text-sm"></i>
            </div>
            <div>
              <p class="text-foreground-900 font-semibold text-sm">Solo 11,300 frecuencias</p>
              <p class="text-foreground-500 text-xs leading-relaxed">En esta etapa inicial, el espectro RFW es limitado. Cada frecuencia es un recurso escaso y valioso.</p>
            </div>
          </div>
          <div class="flex items-start gap-3">
            <div class="w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center shrink-0 mt-0.5">
              <i class="ri-shield-check-line text-primary-600 text-sm"></i>
            </div>
            <div>
              <p class="text-foreground-900 font-semibold text-sm">Acceso por aprobación</p>
              <p class="text-foreground-500 text-xs leading-relaxed">Cada solicitud es revisada manualmente para garantizar calidad y evitar frecuencias abandonadas.</p>
            </div>
          </div>
          <div class="flex items-start gap-3">
            <div class="w-8 h-8 rounded-lg bg-amber-100 flex items-center justify-center shrink-0 mt-0.5">
              <i class="ri-key-2-line text-amber-600 text-sm"></i>
            </div>
            <div>
              <p class="text-foreground-900 font-semibold text-sm">Reserva por aprobación</p>
              <p class="text-foreground-500 text-xs leading-relaxed">Tu frecuencia queda reservada una vez aprobada. Nadie más puede ocupar tu posición en el dial.</p>
            </div>
          </div>
        </div>
        <p class="text-foreground-400 text-[10px] leading-relaxed italic">
          Al registrarte, tu solicitud será evaluada por nuestro equipo. El proceso puede tomar entre 24 y 72 horas.
        </p>
      </div>
    `,
    icon: 'info',
    showCancelButton: true,
    confirmButtonText: 'Solicitar mi frecuencia',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#10b981',
    cancelButtonColor: '#d1d5db',
    customClass: {
      popup: 'rounded-2xl',
      title: 'font-bold text-lg text-foreground-950',
      htmlContainer: 'text-sm',
      confirmButton: 'rounded-lg px-6 py-2.5 text-sm font-bold whitespace-nowrap',
      cancelButton: 'rounded-lg px-6 py-2.5 text-sm font-bold whitespace-nowrap',
    },
    buttonsStyling: false,
  }).then((result) => {
    if (result.isConfirmed) {
      navigate('/register-radio');
    }
  });
}

export default function CtaSection() {
  const navigate = useNavigate();

  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20flowing%20sound%20waves%20in%20deep%20navy%20blue%20tone%2C%20minimalist%20digital%20audio%20visualization%20with%20smooth%20flowing%20curves%2C%20elegant%20broadcast%20waves%20radiating%20from%20center%2C%20dark%20atmospheric%20background%20with%20subtle%20blue%20gradients%2C%20premium%20technology%20aesthetic%2C%20no%20text%2C%20clean%20modern%20style%20with%20sense%20of%20depth%20and%20motion&width=1920&height=800&seq=cta-bg-v1&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-foreground-950/75"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 max-w-7xl mx-auto">
        <div className="max-w-2xl">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-background-50 leading-[1.05] tracking-tight">
            Tu comunidad merece un{' '}
            <span className="text-accent-400">hogar</span>.
          </h2>
          <p className="mt-6 text-base md:text-lg text-background-50/60 max-w-lg leading-relaxed">
            RFW no es solo un reproductor de audio. Somos la red social donde radios, locutores, programas, clubes y oyentes hacen comunidad. Escuchá, compartí, competí, ganá. La comunidad siempre será el producto principal.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-start gap-3">
            <button
              onClick={() => showPremiumSwal(navigate)}
              className="px-7 py-3.5 bg-background-50 hover:bg-background-100 text-foreground-950 font-semibold rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer text-sm shadow-lg flex items-center gap-2"
            >
              Registrar Mi Radio
              <i className="ri-arrow-right-line"></i>
            </button>
            <button
              onClick={() => navigate('/radios')}
              className="px-7 py-3.5 border border-background-50/30 hover:border-background-50/60 text-background-50 font-semibold rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer text-sm flex items-center gap-2"
            >
              Explorar Radios
              <i className="ri-compass-3-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}